"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.array.includes.js");
var _babelHelperVueJsxMergeProps = _interopRequireDefault(require("@vue/babel-helper-vue-jsx-merge-props"));
var _utils = require("../utils");
var _functional = require("../utils/functional");
// Types

var _use = (0, _utils.use)('info'),
  sfc = _use[0],
  bem = _use[1];
function Info(h, props, slots, ctx) {
  var _props$label;
  if (!props.info) {
    return;
  }
  var dot = typeof props.info === 'boolean';
  var single = typeof props.info !== 'boolean' && (props.info + '').length === 1;
  var string = typeof props.info !== 'undefined' && typeof props.info !== 'boolean' && (props.info + '').length > 1;
  // 特殊处理 label
  var label = (_props$label = props.label) === null || _props$label === void 0 ? void 0 : _props$label.length;
  return h("div", (0, _babelHelperVueJsxMergeProps.default)([{
    "class": [bem(), bem(props.type), label && bem('label'), dot && bem('dot'), single && bem('single'), string && bem('string')]
  }, (0, _functional.inherit)(ctx, true)]), [label ? props.label : props.info]);
}
Info.props = {
  info: [Boolean, String, Number],
  type: {
    type: String,
    default: 'text',
    validator: function validator(val) {
      return ['icon', 'text', 'image', 'number'].includes(val);
    }
  },
  label: String
};
var _default = sfc(Info);
exports.default = _default;